module.exports = __webpack_public_path__ + "assets/9d62dbcc242654ffbba11d0621cebfde.mp3";